import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProductService } from 'src/app/services/product.service';
import { Location } from '@angular/common';
import { ManufacturerService } from 'src/app/services/manufacturer.service';
import { AlertService } from 'src/app/services/alert.service';



@Component({
  selector: 'app-manufacturerupdatepopup',
  templateUrl: './manufacturerupdatepopup.component.html',
  styleUrls: ['./manufacturerupdatepopup.component.scss']
})
export class ManufacturerUpdatePopupComponent implements OnInit {
  showNotes: boolean = true;
  form: any;
  id: any;

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private manufacturerService: ManufacturerService,
    private alertService: AlertService,


    private _location: Location,


    public dialogRef: MatDialogRef<ManufacturerUpdatePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,

    public addServiceDialog: MatDialog,
    private navigationService: NavigationService,
  ) { this.id = this.dataRecievedToEdit.id }


  ngOnInit(): void {

    this.showNotes = true;
    this.initializeValidators();
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      remarks: ['', Validators.required]
    })
  }


  next(isProceed) {
    this.dialogRef.close(isProceed);

  }

  goToAction(item: number) {
    // var data = {
      // id: this.id,
      // approvedStatusType: item,
      // remarks: this.form.value.remarks
      this.dataRecievedToEdit.approvedStatusType = item;
      this.dataRecievedToEdit.remarks = this.form.value.remarks;
    // }

    this.manufacturerService.update(this.dataRecievedToEdit).subscribe(res => {
      if (res && res.isSuccess) {
        this.alertService.success('Manufacturer Updated Successfully');
        this.dialogRef.close();
      }
      else {
        this.alertService.error(res.htmlFormattedFailures);
      }
    });
  }

}
